import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { App, Project, ReportDefinition, ReportView } from '../../models';
import { GridColumnProperties, Report, ReportDefinitionHeader } from '../logic-services/models';
import { environment } from './../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
/* istanbul ignore file */
export class ReportsDefinitionDataService extends HttpBaseService {

    route = environment.api + 'apps/';

    constructor(private _httpClient: HttpClient) {
        super(_httpClient);
    }

    createReportDefinition(app: App, project: Project, reportDefinition: ReportDefinition): Observable<any> {
        const url = `${this.route}${app.id}/projects/${project.id}/report-definitions`;
        return this.httpPost(url, reportDefinition);
    }

    updateReportDefinition(app: App, project: Project, reportDefinition: ReportDefinition): Observable<any> {
        const url = `${this.route}${app.id}/projects/${project.id}/report-definitions/${reportDefinition.id}`;
        return this.httpPut(url, reportDefinition);
    }

    removeReportDefinitionFromProject(app: App, project: Project, reportDefinition: ReportDefinition): Observable<any> {
        const url = `${this.route}${app.id}/projects/${project.id}/report-definitions/${reportDefinition.id}`;
        return this.httpDelete(url);
    }

    getReportDefinitionsByProjId(app: App, project: Project): Observable<any> {
        const url = `${this.route}${app.id}/projects/${project.id}/report-definitions`;
        return this.httpGet(url);
    }

    updateReportColumnWidth(app: App, project: Project, reportDefinitionHeader: ReportDefinitionHeader, columnSettings: GridColumnProperties): Observable<Report> {
        const url = `${this.route}${app.id}/projects/${project.id}/report-definitions/${reportDefinitionHeader.id}/column-width`;
        return this.httpPut(url, columnSettings);
    }

    updateReportColumnAggregator(app: App, project: Project, reportDefinitionHeader: ReportDefinitionHeader, columnSettings: GridColumnProperties): Observable<Report> {
        const url = `${this.route}${app.id}/projects/${project.id}/report-definitions/${reportDefinitionHeader.id}/column-aggregator`;
        return this.httpPut(url, columnSettings);
    }

    createNewReportDefinitionView(app: App, project: Project, report: Report, reportView: ReportView): Observable<ReportView> {
        const url = `${this.route}${app.id}/projects/${project.id}/report-definitions/${report.reportDefinitionId}/views`;
        return this.httpPost(url, reportView);
    }

    updateReportView(app: App, project: Project, reportView: ReportView): Observable<ReportView> {
        const url = `${this.route}${app.id}/projects/${project.id}/report-definitions/${reportView.reportDefinitionId}/views/${reportView.id}`;
        return this.httpPut(url, reportView);
    }

    deleteReportView(app: App, project: Project, reportView: ReportView): Observable<ReportView[]> {
        const url = `${this.route}${app.id}/projects/${project.id}/report-definitions/${reportView.reportDefinitionId}/views/${reportView.id}`;
        return this.httpDelete(url);
    }
}
